import { useState } from "react";
import ImportPage from "./pages/ImportPage";
import LessonPage from "./pages/LessonPage";
import SchedulePage from "./pages/SchedulePage";
import "./styles.css";

export default function App() {
  const [page, setPage] = useState("import");

  return (
    <div className="app-shell">
      <header className="topbar">
        <h1>English FSRS MVP</h1>

        <div className="tabs">
          <button
            className={page === "import" ? "tab active" : "tab"}
            onClick={() => setPage("import")}
          >
            Import
          </button>

          <button
            className={page === "lesson" ? "tab active" : "tab"}
            onClick={() => setPage("lesson")}
          >
            Lesson
          </button>

          <button
            className={page === "schedule" ? "tab active" : "tab"}
            onClick={() => setPage("schedule")}
          >
            Schedule
          </button>
        </div>
      </header>

      <main className="page">
        {page === "import" && <ImportPage />}
        {page === "lesson" && <LessonPage />}
        {page === "schedule" && <SchedulePage />}
      </main>
    </div>
  );
}